import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { PersonAvatar } from '@factorialco/factorial-one-react/dist/experimental'
import { OneOnOneParticipantFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import buildUrl from 'modules/core/lib/buildUrl'

interface Props {
  participant: OneOnOneParticipantFragment
}
/**
 * A simple card component that displays a person's avatar, name, job title,
 * and a button to navigate to their profile.
 */
const PersonCard = ({ participant }: Props) => {
  const { navigation } = useNavigation()
  const firstName = participant.firstName || ''
  const lastName = participant.lastName || ''
  const jobTitle =
    participant.referenceContract?.jobCatalogRole || participant.referenceContract?.jobTitle

  return (
    <Box
      padding="s12"
      border={{
        all: {
          style: 'solid',
          width: 's1',
          color: 'grey400',
        },
      }}
      style={{ maxWidth: '100%' }}
      borderRadius={{
        all: 'abs008',
      }}
    >
      <Box width="full" gap="s16" flexDirection="row" justifyContent="spaceBetween">
        <Box justifyContent="flexStart" flexDirection="row" alignItems="center">
          <PersonAvatar
            firstName={firstName}
            lastName={lastName}
            size="medium"
            src={participant.avatar?.url ? buildUrl(participant.avatar.url) : undefined}
          />
          <Box paddingLeft="s24" alignItems="flexStart">
            <Text.Normal weight="medium" color="grey1000">
              {participant.fullName}
            </Text.Normal>
            {jobTitle && (
              <Text.Normal size="200" color="grey800" weight="medium">
                {jobTitle}
              </Text.Normal>
            )}
          </Box>
        </Box>
        <Box alignItems="center" justifyContent="flexEnd" flexDirection="row">
          <Button.Router
            to={navigation.employees.id.fullPath({ id: participant.id })}
            type="secondary"
            iconName="arrow-right"
          />
        </Box>
      </Box>
    </Box>
  )
}

export default PersonCard
